package com.patronat.top.ui.components.organisms

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Divider
import androidx.compose.material3.Surface
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.molecules.header.PageTitleBlock
import com.patronat.top.ui.components.molecules.header.UserProfileBlock
import com.patronat.top.ui.theme.MineShaft100
import com.patronat.top.ui.theme.White

@Composable
fun AdminPageHeader(
    title: String,
    description: String? = null,
    userName: String,
    userRole: String,
    userInitials: String,
    modifier: Modifier = Modifier,
    backgroundColor: Color = White,
    showDivider: Boolean = true
) {
    Surface(
        modifier = modifier.fillMaxWidth(),
        color = backgroundColor
    ) {
        Column {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(68.dp)
                    .padding(horizontal = 24.dp),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                PageTitleBlock(
                    title = title,
                    description = description,
                    modifier = Modifier.weight(1f, fill = false)
                )

                Spacer(modifier = Modifier.width(16.dp))

                UserProfileBlock(
                    userName = userName,
                    userRole = userRole,
                    initials = userInitials
                )
            }

            if (showDivider) {
                Divider(
                    color = MineShaft100,
                    thickness = 1.dp
                )
            }
        }
    }
}